// src/components/ProfilePage.js
import React from 'react';
import './ProfilePage.css'; // We will create this too

const ProfilePage = ({ user, onBack }) => {
  return (
    <div className="profile-container">
      <div className="profile-card">
        <button className="back-button" onClick={onBack}>&larr; Back to Search</button>
        <h2>{user.username}'s Profile</h2>
        <div className="profile-details">
          <p><strong>Date of Birth:</strong> {user.dob}</p>
          <p><strong>Occupation:</strong> {user.occupation}</p>
          <h3>About Me</h3>
          <p>{user.about}</p>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;